var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"div"},[_c('img',{attrs:{"src":require("./404.png")}}),_c('div',{staticClass:"right-text"},[_c('div',{staticClass:"none"},[_vm._v("404")]),_c('span',[_vm._v("页面发生了错误")])])])
}]

export { render, staticRenderFns }